/**
 * Labstep
 */

import type { ColDef } from 'ag-grid-community';
import { GridBatchCreateResourceItemsColumnHeader } from 'labstep-web/grid/BatchCreateResourceItems/components/ColumnHeader';
import type { Resource } from 'labstep-web/models/resource.model';

export const colDefBatchCreateResourceItemsAddColumn = (
  resource: Resource,
): ColDef => {
  return {
    headerName: 'Add Column',
    colId: 'add_column',
    lockPosition: 'right',
    pinned: 'right',
    cellStyle: { paddingLeft: 0, paddingRight: 0 },
    resizable: false,
    editable: false,
    headerComponent: GridBatchCreateResourceItemsColumnHeader,
    headerComponentParams: {
      icon: 'plus',
      isAddColumn: true,
      resource: resource,
    },
  };
};
